import React, {
  createRef,
  CSSProperties,
  ReactNode,
  Ref,
  RefObject,
  useEffect
} from 'react';
import { isWeb } from '../../utils/util';
import { style } from '../../utils/image';
import './Video.scss';

interface X5Video {
  children: ReactNode;
  id: number | string;
  onPlay?: () => void;
  autoPlay?: boolean;
  poster?: string;
  fullscreen?: boolean;
  bgToggle?: (hide: boolean) => void;
  style?: CSSProperties;
  videoStyle?: CSSProperties;
  seondUrl?: string;
  type?: string;
  beginAt?: string;
  endAt?: string;
  cover?: any;
}
const cW = isWeb() ? 750 : document.documentElement.clientWidth;

const X5Video = React.forwardRef<HTMLVideoElement, X5Video>((props, ref) => {
  const { autoPlay, poster } = props;
  useEffect(() => {
    const hideVideo = function() {
      props.bgToggle && props.bgToggle(false);
      // @ts-ignore
      if (ref && (ref.current as HTMLVideoElement)) {
        // @ts-ignore
        ref.current.pause();
      }
    };
    window.addEventListener('hide-video', hideVideo, false);
    return () => {
      window.removeEventListener('hide-video', hideVideo);
    };
  }, []);
  //不要设置最小高度，否则在滚动固定的.video-portal-wrapper上显示会不好
  //web上没有最小高度的情况下用videojs会杯具
  const theStyle = Object.assign(
    { width: '100%', height: 210, margin: '0 auto' },
    // !window.isweixin && {
    //   minHeight: (210 / 375) * cW
    // },
    // {
    //   // 竖屏会显示异常，如果不做maxHeight的话，在微信PC上会非常巨大
    //   // 目前最小的手机高度至少也应该有320（360），保留一点空隙给底部评论
    //   maxHeight: isWeb() ? 560 : 280
    // },
    props.style
  );

  const videoDomStyle = Object.assign(
    { width: '100%', height: '100%' },
    props.videoStyle
  );
  // console.log(theStyle);

  return (
    <div className="video-x5-player" style={theStyle}>
      <video
        ref={ref}
        id={props.id + ''}
        onPlay={props.onPlay}
        className="video-js vjs-big-play-centered"
        // 参考https://zhuanlan.zhihu.com/p/27559167
        // 千万不要设置这 h5的属性，否则播放会变成全屏
        // x5-video-player-type="h5"
        // ios通过设置这个来控制是否全屏
        // 关于视频相关请参考readme中相关描述
        playsInline={props.fullscreen ? false : true}
        autoPlay={autoPlay || false}
        // 这个能保证安卓上的行内播放
        x5-playsinline="true"
        controls={true}
        // style={theStyle}
        // https://developer.mozilla.org/zh-CN/docs/Web/HTML/Element/video
        // 不需要一开始进入的时候就缓存（流量节省）
        preload={'meta'}
        poster={poster}
        style={videoDomStyle}
      >
        {props.children}
        您的浏览器不支持视频播放
      </video>
      {props.cover}
    </div>
  );
});

export default X5Video;
